<div class="dialog-header">
  <h2 mat-dialog-title>Aggiunta rapida</h2>
  <button
    mat-icon-button
    type="button"
    (click)="onNoClick()"
    matTooltip="Chiudi"
    [matTooltipShowDelay]="showDelay.value"
    [matTooltipHideDelay]="hideDelay.value"
    class="dialog-close-btn custom-button-border"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<p class="ms-4 small text-muted">
  I campi contrassegnati da * sono obbligatori.
</p>

<form #CompanyForm="ngForm" (ngSubmit)="addNewCompany()" class="company-form">

<mat-dialog-content>

      <div class="form-container">

        <h5 class="mb-3">Nuovo cliente</h5>
        <p class="text-muted small">
          Inserisci i dati essenziali del cliente: potrai completarli in seguito dall'anagrafica.
        </p>

        <div class="mt-2 row">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Nome Cliente</mat-label>
            <input
              matInput
              [(ngModel)]="newCompany.company_name"
              name="company_name"
              matTooltip="La ragione sociale dell'azienda o il nome e cognome della persona che stai registrando."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-50-mobile-50">
            <mat-label>Tipo</mat-label>
            <mat-select
              class="izy-select-trigger"
              panelClass="izy-select-panel izy-select-panel--form"
              [(ngModel)]="newCompany.type"
              name="type"
              matTooltip="Il tipo di soggetto che stai registrando."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            >
              <mat-option *ngFor="let type of typeOptions" [value]="type.code">
                {{ type.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-50-mobile-50">
            <mat-label>Codice SDI</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newCompany.addressee_code"
              name="addressee_code"
              required
              minlength="6"
              maxlength="7"
              pattern="^[A-Z0-9]*"
              matTooltip="Il codice SDI a cui vengono recapitate le fatture elettroniche del cliente. Se non lo conosci, usa 0000000."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
              #SDI_CodeInput="ngModel"
            />
            <mat-error *ngIf="SDI_CodeInput.invalid && (SDI_CodeInput.dirty || SDI_CodeInput.touched)">
              Il Codice SDI deve essere composto esattamente da 6 o 7 caratteri alfanumerici maiuscoli
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-100">
            <mat-label>Partita IVA</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newCompany.iva_number"
              name="iva_number"
              minlength="11"
              maxlength="11"
              pattern="[0-9]*"
              (ngModelChange)="onPartitaIvaChange($event)"
              (input)="onPartitaIvaInput($event)"
              (blur)="validatePartitaIva(newCompany.iva_number)"
              matTooltip="La Partita IVA del cliente (11 cifre). Devi indicare almeno uno fra Partita IVA e Codice Fiscale."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
              #iva_numberInput="ngModel"
            />
            <mat-error *ngIf="iva_numberInput.invalid && (iva_numberInput.dirty || iva_numberInput.touched)">
              La Partita Iva deve essere composta esattamente da 11 cifre
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Codice fiscale</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newCompany.c_f"
              name="c_f"
              maxlength="16"
              pattern="([A-Z0-9]{11}|[A-Z0-9]{16})"
              matTooltip="Il Codice Fiscale del cliente (11 o 16 caratteri). Devi indicare almeno uno fra Partita IVA e Codice Fiscale."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
              #CFInput="ngModel"
            />
            <mat-error *ngIf="CFInput.invalid && (CFInput.dirty || CFInput.touched)">
              Il Codice Fiscale deve essere composto esattamente da 11 o 16 caratteri alfanumerici
            </mat-error>
          </mat-form-field>
        </div>

        <h5 class="mt-2 mb-3">Dati anagrafici</h5>

        <div class="row">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Indirizzo</mat-label>
            <input
              matInput
              [(ngModel)]="newCompany.address"
              name="address"
              matTooltip="Via e numero civico della sede del cliente."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Città</mat-label>
            <input
              matInput
              [(ngModel)]="newCompany.city"
              name="city"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-50-mobile-50">
            <mat-label>CAP</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newCompany.cap"
              name="cap"
              required
              minlength="5"
              maxlength="5"
              pattern="[0-9]*"
              matTooltip="Il codice di avviamento postale (5 cifre)."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
              #CAP_CodeInput="ngModel"
            />
            <mat-error *ngIf="CAP_CodeInput.invalid && (CAP_CodeInput.dirty || CAP_CodeInput.touched)">
              Il CAP deve essere composto esattamente da 5 cifre
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-50-mobile-50">
            <mat-label>Comune</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newCompany.comune"
              name="comune"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-50">
            <mat-label>Provincia</mat-label>
            <input
              matInput
              [(ngModel)]="newCompany.province"
              name="province"
              required
              minlength="2"
              maxlength="2"
              pattern="[A-Z]*"
              (ngModelChange)="onProvinceChange($event)"
              (input)="onProvinceInput($event)"
              (blur)="validateProvince(newCompany.province)"
              matTooltip="La sigla della provincia, in due lettere maiuscole (es. MI, RM)."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
              #provinceInput="ngModel"
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-50">
            <mat-label>Nazione</mat-label>
            <mat-select
              class="izy-select-trigger"
              panelClass="izy-select-panel izy-select-panel--form"
              [(ngModel)]="newCompany.country"
              name="country"
              required
            >
              <mat-option *ngFor="let country of countryOptions" [value]="country.code">
                {{ country.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

      </div>

</mat-dialog-content>

<mat-dialog-actions>
  <button
    type="button"
    mat-stroked-button
    [mat-dialog-close]="company_to_register()"
    class="izy-button-ghost custom-button-border"
    matTooltip="Chiudi senza salvare il cliente."
    [matTooltipShowDelay]="showDelay.value"
    [matTooltipHideDelay]="hideDelay.value"
  >
    <mat-icon>close</mat-icon>
    Esci
  </button>
  <button
    mat-raised-button
    type="submit"
    [disabled]="!CompanyForm.valid"
    matButton="filled"
    class="primary-button custom-button-border"
    matTooltip="Salva il cliente nella tua anagrafica."
    [matTooltipShowDelay]="showDelay.value"
    [matTooltipHideDelay]="hideDelay.value"
  >
    <mat-icon>person_add</mat-icon>
    Aggiungi cliente
  </button>
</mat-dialog-actions>

</form>
